var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4987 4.25833V0.25H7.4987V4.25833C6.00703 5.125 4.9987 6.73333 4.9987 8.58333C4.9987 11.3417 7.24036 13.5833 9.9987 13.5833C12.757 13.5833 14.9987 11.3417 14.9987 8.58333C14.9987 6.73333 13.9904 5.125 12.4987 4.25833ZM0.832031 7.75H3.33203V9.41667H0.832031V7.75ZM2.95768 14.4502L4.13268 15.6252L5.62435 14.1252L4.44935 12.9502L2.95768 14.4502ZM9.16537 17.7083H10.832V15.25H9.16537V17.7083ZM19.1654 9.41667H16.6654V7.75H19.1654V9.41667ZM14.3656 14.1331L15.8572 15.6331L17.0322 14.4581L15.5322 12.9665L14.3656 14.1331Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.204094a438e2dc483ad3b65d638188e6.svg";
export { ForwardRef as ReactComponent };